<template>
  <button
    type="button"
    tabindex="-1"
    :class="$style.root"
    :aria-label="$t('columnFilter.condition.remove')"
    :title="$t('columnFilter.condition.remove')"
    test-id="column-filter-remove"
    @pointerdown.stop
    @mousedown.prevent
    @click.stop="emit('remove')"
  >
    <SCASvgIcon icon="phosphor/trash" size="12px" />
  </button>
</template>

<script setup lang="ts">
import { $t } from "../../../i18n";
import SCASvgIcon from "../../SCASvgIcon.vue";

const emit = defineEmits<{
  remove: [];
}>();
</script>

<style module lang="scss">
@use "../../../styles/icon.scss" as IconMixins;

// The row that owns the button decides when it shows.
.root {
  visibility: var(--column-filter-remove-visibility, hidden);
  display: flex;
  flex: none;
  padding: 0;
  border: none;
  background: transparent;
}

.root svg {
  @include IconMixins.icon-color(var(--color-content-disabled));
  @include IconMixins.icon-clickable;
}
</style>
